<div class="container !bg-[#ffffff] p-0 relative" id="">
  <div
    class="container-fluid flex justify-center h-auto !pt-0 !m-[0px] !pb-[0px]"
  >
    <div class="w-full !mb-[20px]">
      <div class="!p-[0px] !pb-0 !pt-[0px]">
        <!-- Header -->
        <div
          class="flex justify-between items-center !pt-[16px] !pl-[40px] !pr-[40px] !bg-[#CFD4DA] sticky top-0 z-50"
        >
          <div class="flex flex-col items-end">
            <h3 class="!p-0 !m-0">Pre-Qualification Questionnaire (PQQ)</h3>
          </div>
          <div class="flex items-center gap-[10px]">
            <img
              src="assets/icons/cross-icon.svg"
              alt="cross icon"
              style="
                position: absolute;
                top: 7px;
                right: 4px;
                z-index: 40;
                margin: 10px;
              "
              class="cursor-pointer"
              (click)="closeDialog()"
            />
          </div>
        </div>

        <!-- Logo and Print button -->
        <div
          class="flex justify-end items-center gap-[10px] mx-[40px] my-[6px]"
        >
          <!-- Updated container -->
          <button class="print-button" (click)="handlePrint()">Print</button>
          <!-- Positioned with 10px gap -->
          <img
            src="assets/images/logo.png"
            alt="logo"
            class="h-[57px] w-[57px] rounded-[7px]"
          />
        </div>

        <div id="pqqDeveloperCompanyResponseView">
          <!-- Project Detail -->
          <div>
            <div
              class="flex justify-between items-center !pt-[16px] !pb-[16px] !pl-[40px] !pr-[40px] !bg-[#F3F3F3]"
            >
              <div class="flex flex-col items-end">
                <h3 class="!p-0 !m-0">Project Brief</h3>
              </div>
            </div>
            <app-project-brief></app-project-brief>
          </div>

          <!-- Work Packages -->
          <div
            class="flex justify-between items-center !pt-[16px] !pb-[16px] !pl-[40px] !pr-[40px] !bg-[#F3F3F3]"
          >
            <div class="flex flex-col items-end">
              <h3 class="!p-0 !m-0">Selected Work Packages</h3>
            </div>
          </div>
          <div class="mx-[40px] mt-[7px]">
            <div
              *ngFor="
                let wpDetail of initiatedSelectedWorkPackages;
                let i = index
              "
              class="w-[100%] !h-[30px] flex justify-between items-center"
            >
              <div class="flex justify-start">
                <p class="packages-name">{{ wpDetail?.name }}</p>
              </div>
            </div>
          </div>

          <!-- PQQ DATA -->
          <div
            class="flex justify-between items-center !pt-[16px] !pb-[16px] !pl-[40px] !pr-[40px] !bg-[#F3F3F3]"
          >
            <div class="flex flex-col items-end">
              <h3 class="!p-0 !m-0 !text-[18px]">
                Pre Qualification Questionnaire PQQ
              </h3>
            </div>
          </div>
          <div class="mx-[40px]">
            <!-- Company Information -->
            <h2 class="!pt-[10px]">General Company Information</h2>
            <h5>Company Details</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Full Legal Name of Company </label>
                    <p>{{ pqqData?.company_name }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Registered Address </label>
                    <p>{{ pqqData?.address }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Company Registration Number  </label>
                    <p>{{ pqqData?.company_reg_no }}</p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> VAT Number  </label>
                    <p>{{ pqqData?.company_vat_no }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Telephone Number </label>
                    <p>{{ pqqData?.phone }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Email Address  </label>
                    <p>{{ pqqData?.email }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !m-0">
                    <label> Website </label>
                    <p>
                      <a style="color: #2368a2" href="{{ pqqData?.website }}">{{
                        pqqData?.website
                      }}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Contact Person</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Name </label>
                    <p>{{ pqqData?.contact_person }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Position </label>
                    <p>{{ pqqData?.contact_person_position }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Telephone Number </label>
                    <p>{{ pqqData?.contact_person_phone }}</p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Email Address </label>
                    <p>{{ pqqData?.contact_person_email }}</p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Organization Structure</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Legal Status </label>
                    <p>{{ pqqData?.legal_status }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Year Established  </label>
                    <p>{{ pqqData?.year_established }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Parent Company </label>
                    <p>{{ pqqData?.parent_company }}</p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Number of Direct Employees  </label>
                    <p>{{ pqqData?.direct_employees }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Number of Subcontractors Regularly Used  </label>
                    <p>{{ pqqData?.subcontractor_count }}</p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Company Size</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Annual Turnover for the Past 3 Years </label>
                    <p>{{ pqqData?.annual_turnover }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label>
                      Number of Projects Completed (last 3 years) 
                    </label>
                    <p>{{ pqqData?.completed_projects }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Total Number of Ongoing Projects </label>
                    <p>{{ pqqData?.ongoing_projects }}</p>
                    <p></p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Health, Safety, and Environmental Management -->
            <h2 class="!pt-[15px]">
              Health, Safety, and Environmental Management 
            </h2>
            <h5 class="!pt-[3px]">Health and Safety Policy</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[12px] pt-[7px]">
                    <label
                      >Do you have a Health and Safety Policy in place?
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.has_health_policy === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.has_health_policy === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <app-attachment-list
                [attachments]="pqqData?.health_safety_policy_attach"
              >
              </app-attachment-list>
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[12px] pt-[7px]">
                    <label
                      >Have you had any reportable incidents (e.g., RIDDOR) in
                      the past three years? If yes, please provide details.
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.health_incidents === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.health_incidents === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="pqqData?.health_incidents === 1"
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label> Details </label>
                    <p>
                      {{ pqqData?.health_incident_details }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Safety Accreditation</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label class="block">
                      Please provide evidence of any Health and Safety
                      accreditations (e.g., CHAS, Safe Contractor)
                    </label>
                    <!-- <a
                    [href]="baseUrl + pqqData?.safety_accr_attach"
                    class=" border !rounded-[20px] h-[25px] !w-[fit-content] bg-[#DFDFDF33] flex items-center justify-center px-[15px]"
                    download
                  >
                    Health_Safety_Policy_2024.pdf
                  </a> -->
                    <app-attachment-list
                      [attachments]="pqqData?.safety_accr_attach"
                    ></app-attachment-list>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Environmental Policy</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px] pt-[7px]">
                    <label
                      >Do you have an Environmental Management Policy in place? 
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.has_env_policy === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.has_env_policy === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.environmental_policy_attach"
                ></app-attachment-list>
              </div>
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label class="block">
                      Provide details of any environmental accreditations (e.g.,
                      ISO 14001)
                    </label>
                    <!-- <a
                    [href]="baseUrl + pqqData?.env_accr_attach"
                    class=" border !rounded-[20px] h-[25px] !w-[fit-content] bg-[#DFDFDF33] flex items-center justify-center px-[15px]"
                    download
                  >
                    ISO_45001_Certificate.pdf
                  </a> -->
                    <app-attachment-list
                      [attachments]="pqqData?.env_accr_attach"
                    ></app-attachment-list>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full">
                    <label>
                      Describe any sustainability initiatives your company is
                      involved in
                    </label>
                    <p>
                      {{
                        pqqData?.sustainability_initiatives
                          ? pqqData?.sustainability_initiatives
                          : "None"
                      }}
                    </p>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.sustainability_initiative_attach"
                ></app-attachment-list>
              </div>
            </div>

            <!--  Technical and Professional Capability -->
            <h2 class="!pt-[25px]">Technical and Professional Capability</h2>
            <h5 class="!pt-[3px]">Relevant Construction Experience</h5>
            <h5 class="!pt-[3px]">
              Provide details of up to three construction projects that are
              similar in scope and size to this procurement. Include the
              following: 
            </h5>

            <ng-container
              *ngFor="let project of pqqData?.sample_projects; let i = index"
            >
              <h5 class="!pt-[3px]">Construction project {{ i + 1 }}</h5>
              <div
                class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
              >
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> Project Name </label>
                      <p>{{ project?.project_name }}</p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> Client Name </label>
                      <p>{{ project?.client_name }}</p>
                    </div>
                  </div>
                </div>

                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> Start Date </label>
                      <p>
                        {{ DateFormatService.formatDate(project?.start_date) }}
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> End Date </label>
                      <p>
                        {{
                          DateFormatService.formatDate(project?.completion_date)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> Project Value </label>
                      <p>{{ project?.project_value }}</p>
                    </div>
                  </div>
                </div>

                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label>
                        Your Role ( Main Contractor/Sub Contractor)
                      </label>
                      <p>{{ project?.role }}</p>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label> Description of Work </label>
                      <p>{{ project?.description_of_work }}</p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <div class="rounded !pb-0 !pt-0">
                    <div class="!w-[500px]">
                      <label>
                        Any Challenges Faced and How They Were Overcome
                      </label>
                      <p>{{ project?.challenges_faced }}</p>
                    </div>
                  </div>
                </div>
                <div class="container !pt-0 !pb-0">
                  <app-attachment-list
                    [attachments]="pqqData?.['construction_project' + (i + 1) + '_attach']"
                  ></app-attachment-list>
                </div>
              </div>
            </ng-container>

            <h5 class="!pt-[3px]">Key Personnel</h5>
            <h5 class="!pt-[3px]">
              List the key personnel proposed for this project, including:
            </h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Name </label>
                    <p>{{ pqqData?.key_personnel_name }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Role of the Project </label>
                    <p>{{ pqqData?.key_personnel_role }}</p>
                  </div>
                </div>
              </div>

              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Qualification </label>
                    <p>{{ pqqData?.key_personnel_qualifications }}</p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label> Experience </label>
                    <p>{{ pqqData?.key_personnel_experience }}</p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Subcontractors and Supply Chain</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px] mt-[7px]">
                    <label
                      >Do you intend to use subcontractors for this project? If
                      yes, provide details of key subcontractors and their scope
                      of work.
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.use_subcontractors"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="!pqqData?.use_subcontractors"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="pqqData?.use_subcontractors"
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label> Details </label>
                    <p>
                      {{ pqqData?.subcontractor_scope_of_work }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full">
                    <label>
                      Describe how you manage your supply chain and ensure
                      subcontractor compliance with project standards. 
                    </label>
                    <p>
                      {{ pqqData?.supply_chain_management }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          <!--  Quality Management -->
          <h2 class="!pt-[25px]">Quality Management</h2>
          <h5 class="!pt-[3px]">Quality Management System (QMS)</h5>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-[500px]  pt-[7px]">
                  <label> Do you have a documented QMS? </label>
                </div>
              </div>
            </div>
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-[500px] !mb-[25px]">
                  <mat-radio-group
                    aria-label="Select an option "
                    class="ml-[40px] !mb-10"
                  >
                    <mat-radio-button
                      class="mr-[25px]"
                      value="1"
                      disabled="true"
                      [checked]="pqqData?.using_qms === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="2"
                      disabled="true"
                      [checked]="pqqData?.using_qms === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-full ">
                  <label>
                    Provide details of any quality certifications (e.g., ISO
                    9001)
                  </label>
                  <p>
                    {{ pqqData?.quality_certifications_detail }}
                  </p>
                </div>
              </div>
              <app-attachment-list 
                [attachments]="pqqData?.parent_document"
                [config]="{ filter_key: 'type', 
                  filter_value: 'quality_certification_attach' 
                }">
              </app-attachment-list>
            </div>
          </div>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-full">
                  <label>
                    How do you ensure compliance with quality standards on
                    construction rojects?
                  </label>
                  <p>
                    {{ pqqData?.compliance_process }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h5 class="!pt-[3px]">Quality Management System (QMS)</h5>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-full ">
                  <label>
                    Outline your approach to managing construction defects
                    during and after project completion.
                  </label>
                  <p>
                    {{ pqqData?.defects_management }}
                  </p>
                </div>
              </div>
              <app-attachment-list 
                [attachments]="pqqData?.parent_document"
                [config]="{ filter_key: 'type', 
                  filter_value: 'quality_standard_attach' 
                }">
              </app-attachment-list>
            </div>
          </div>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <div class="!w-full ">
                  <label> Warranty Period </label>
                  <p>
                    {{ pqqData?.warranty_period }}
                  </p>
                </div>
              </div>
              <app-attachment-list 
                [attachments]="pqqData?.parent_document"
                [config]="{ filter_key: 'type', 
                  filter_value: 'defects_&_warranty_attach' 
                }">
              </app-attachment-list>
            </div>
          </div>

            <!--  Financial and Insurance Information -->
            <h2 class="!pt-[25px]">Financial and Insurance Information</h2>
            <h5 class="!pt-[3px]">Financial Information</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label>
                      Annual Turnover for the Last Three (3) Years:
                    </label>
                    <p>
                      {{ pqqData?.fin_3_y_turnover }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full">
                    <label class="block">
                      Provide a copy of your most recent audited financial
                      accounts.
                    </label>
                    <!-- <a
                    [href]="baseUrl + pqqData?.accounts_audit_report_attach"
                    class=" border !rounded-[20px] h-[25px] !w-[fit-content] bg-[#DFDFDF33] flex items-center justify-center px-[15px] mt-[0.5rem]"
                    download
                  >
                  Audited_Financial_Accounts_2023.pdf
                  </a> -->
                    <app-attachment-list
                      [attachments]="pqqData?.parent_document"
                      [config]="{
                        filter_key: 'type',
                        filter_value: 'accounts_audit_report_attach'
                      }"
                    >
                    </app-attachment-list>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px]">
                    <label>
                      Have you experienced any financial difficulties in the
                      last five (5) years (e.g., insolvency, administration)?
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="
                          pqqData?.has_faced_financial_difficulty === 1
                        "
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="
                          pqqData?.has_faced_financial_difficulty === 0
                        "
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Insurance Cover</h5>
            <p class="!pt-[3px]">
              Provide evidence of the following insurance policies:
            </p>

            <h5 class="!pt-[3px]">Employer's Liability Insurance</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Limit </label>
                    <p>{{ pqqData?.insurance_employer_limit }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Expiry Date </label>
                    <p>
                      {{
                        DateFormatService.formatDate(
                          pqqData?.insurance_employer_expiry_date
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Public Liability Insurance</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Limit </label>
                    <p>{{ pqqData?.insurance_public_liability_limit }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Expiry Date </label>
                    <p>
                      {{
                        DateFormatService.formatDate(
                          pqqData?.insurance_public_liability_expiry_date
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Professional Indemnity Insurance</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Limit </label>
                    <p>{{ pqqData?.insurance_professional_indemnity_limit }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Expiry Date </label>
                    <p>
                      {{
                        DateFormatService.formatDate(
                          pqqData?.insurance_professional_indemnity_expiry_date
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Contract Works Insurance (if applicable)</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Limit </label>
                    <p>{{ pqqData?.insurance_contract_works_limit }}</p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Expiry Date </label>
                    <p>
                      {{
                        DateFormatService.formatDate(
                          pqqData?.insurance_contract_works_expiry_date
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <app-attachment-list
                [attachments]="pqqData?.parent_document"
                [config]="{
                  filter_key: 'type',
                  filter_value: 'insurance_attach'
                }"
              >
              </app-attachment-list>
            </div>

            <!--   Compliance and Legal Information -->
            <h2 class="!pt-[25px]">Compliance and Legal Information</h2>
            <h5 class="!pt-[3px]">Legal Compliance</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px] pt-[7px]">
                    <label>
                      Have there been any regulatory actions or prosecutions
                      against your company in the last five (5) years? 
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.has_prosecutions === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.has_prosecutions === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px] pt-[7px]">
                    <label>
                      Are you currently involved in any legal disputes related
                      to construction projects? If yes, provide details.
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.has_current_legal_dispute === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.has_current_legal_dispute === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="pqqData?.has_current_legal_dispute === 1"
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label> Details </label>
                    <p>
                      {{ pqqData?.current_legal_dispute_details }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="!pt-[3px]">Legal Compliance</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px] pt-[7px]">
                    <label>
                      Confirm your organisation adheres to anti-bribery,
                      anti-corruption, and ethical business practices.
                    </label>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <mat-radio-group
                      aria-label="Select an option "
                      class="ml-[40px] !mb-10"
                    >
                      <mat-radio-button
                        class="mr-[25px]"
                        value="1"
                        disabled="true"
                        [checked]="pqqData?.confirm_business_practices === 1"
                        >Yes</mat-radio-button
                      >
                      <mat-radio-button
                        value="2"
                        disabled="true"
                        [checked]="pqqData?.confirm_business_practices === 0"
                        >No</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-full !mb-[25px]">
                    <label class="block">
                      Provide details of any accreditations related to ethical
                      practices (e.g., Ethical Trading Initiative):
                    </label>
                    <!-- <a
                    [href]="baseUrl + pqqData?.ethical_practices_accreditations_attach"
                    class=" border !rounded-[20px] h-[25px] !w-[fit-content] bg-[#DFDFDF33] flex items-center justify-center px-[15px] mt-[0.5rem]"
                    download
                  >
                  Ethical_Practice_Accredation.pdf
                  </a> -->
                    <app-attachment-list
                      [attachments]="pqqData?.parent_document"
                      [config]="{
                        filter_key: 'type',
                        filter_value: 'ethical_practices_accreditations_attach'
                      }"
                    >
                    </app-attachment-list>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sustainability and Social Value -->
            <h2 class="!pt-[3px]">Sustainability and Social Value</h2>
            <h5 class="!pt-[3px]">Sustainability</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label>
                      Outline how your company promotes sustainability in
                      construction projects.
                    </label>
                    <p>
                      {{ pqqData?.sustainability_outline }}
                    </p>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.parent_document"
                  [config]="{
                    filter_key: 'type',
                    filter_value: 'sust_construction_project_attach'
                  }"
                >
                </app-attachment-list>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label>
                      Provide examples of any sustainability initiatives or
                      innovations on previous projects
                    </label>
                    <p>
                      {{ pqqData?.sustainability_initiatives_taken }}
                    </p>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.parent_document"
                  [config]="{
                    filter_key: 'type',
                    filter_value: 'sust_initiatives_innovations_attach'
                  }"
                >
                </app-attachment-list>
              </div>
            </div>

            <h5 class="!pt-[3px]">Social Value</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label>
                      Describe how your company contributes to the local
                      community and the wider industry
                    </label>
                    <p>
                      {{ pqqData?.social_contributions_community_and_industry }}
                    </p>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.parent_document"
                  [config]="{
                    filter_key: 'type',
                    filter_value: 'company_contributes_attach'
                  }"
                >
                </app-attachment-list>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label>
                      Are you involved in any corporate social responsibility
                      (CSR) Initiatives?
                    </label>
                    <p>
                      {{ pqqData?.corporate_social_initiatives }}
                    </p>
                  </div>
                </div>
                <app-attachment-list
                  [attachments]="pqqData?.parent_document"
                  [config]="{
                    filter_key: 'type',
                    filter_value: 'corporate_social_responsibility_attach'
                  }"
                >
                </app-attachment-list>
              </div>
            </div>

            <!-- Refrences -->
            <h2 class="!pt-[3px]">Refrences</h2>
            <h5 class="!pt-[3px] !text-[18px] !font-semibold">
              Provide two references from recent construction projects. Include
              the following details:
            </h5>
            <ng-container *ngIf="pqqData?.references">
              <ng-container
                *ngFor="let reference of pqqData?.references; let i = index"
              >
                <h5 class="!pt-[3px]">Reference {{ i + 1 }}</h5>
                <div
                  class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
                >
                  <div class="container !pt-0 !pb-0">
                    <div class="rounded !pb-0 !pt-0">
                      <div class="!w-[500px]">
                        <label> Client Name </label>
                        <p>
                          {{
                            reference?.client_name ? reference?.client_name : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="container !pt-0 !pb-0">
                    <div class="rounded !pb-0 !pt-0">
                      <div class="!w-[500px]">
                        <label> Project Title </label>
                        <p>
                          {{
                            reference?.project_title
                              ? reference?.project_title
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="container !pt-0 !pb-0">
                    <div class="rounded !pb-0 !pt-0">
                      <div class="!w-[500px]">
                        <label> Contact person </label>
                        <p>
                          {{
                            reference?.contact_person
                              ? reference?.contact_person
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="container !pt-0 !pb-0">
                    <div class="rounded !pb-0 !pt-0">
                      <div class="!w-[500px]">
                        <label> Email Address </label>
                        <p>
                          {{ reference?.email ? reference?.email : "" }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="container !pt-0 !pb-0">
                    <div class="rounded !pb-0 !pt-0">
                      <div class="!w-[500px] !mb-[25px]">
                        <label> Telephone Number </label>
                        <p>
                          {{ reference?.phone ? reference?.phone : "" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- Declaration -->
            <h2 class="!pt-[3px]">Declaration</h2>
            <h5 class="!pt-[3px] text-[18px] font-semibold">
              I confirm that the information provided in this Pre-Qualification
              Questionnaire is accurate and complete. I understand that false
              information could result in disqualification from this procurement
              process.
            </h5>
            <h5 class="!pt-[3px]">Authorized Signatory</h5>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Name </label>
                    <p>
                      {{ pqqData?.authorized_signatory_name }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Position </label>
                    <p>
                      {{ pqqData?.authorized_signatory_position }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Date </label>
                    <p>
                      {{
                        DateFormatService.formatDate(
                          pqqData?.authorized_signatory_signature_date
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div class="!w-[500px] !mb-[25px]">
                    <label> Signature </label>
                    <p>
                      {{ pqqData?.authorized_signatory_signature }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
